import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import { AuthProvider } from 'react-oidc-context'

const cognitoAuthConfig = {
  authority: process.env.REACT_APP_COGNITO_URL,
  client_id: process.env.REACT_APP_COGNITO_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URL,
  response_type: 'code',
  scope: 'email phone openid profile',

  onSigninCallback: (_user) => {
    window.history.replaceState({}, document.title, window.location.pathname)
  },
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
)

reportWebVitals(console.log)
